const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const bulkDeleteLeadsApi = async (leadIds) => {
    const token = localStorage.getItem('token');
    
    if (!token) {
        throw new Error('Токен авторизации не найден.');
    }

    try {
        const response = await fetch(
            `${API_BASE_URL}/admin/lead/leads/bulk-delete`, 
            {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/json',
                },
                body: JSON.stringify({ lead_ids: leadIds }),
            }
        );

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData?.message || `Ошибка ${response.status}: не удалось удалить лиды.`);
        }
        

        return true; 
        
    } catch (error) {
        console.error("Ошибка при массовом удалении лидов:", error);
        throw error;
    }
};